import { render, staticRenderFns } from "./ViewCommercant.vue?vue&type=template&id=685ebcad&"
import script from "./ViewCommercant.vue?vue&type=script&lang=js&"
export * from "./ViewCommercant.vue?vue&type=script&lang=js&"
import style0 from "./ViewCommercant.vue?vue&type=style&index=0&id=685ebcad&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports